import { RELAY_API_CONTENTFUL } from "@/utils/constant";

import {
    PricingPageRelayQuery,
    getPricingPageRelayQueryVars
} from "../contentful/graphql";
import { init as initRelay } from "../init-relay";
import { TeamworkCollectionPricingPage } from "../pages/collections/teamwork/pricing/teamwork-collection-pricing-page";

initRelay(
    TeamworkCollectionPricingPage,
    PricingPageRelayQuery,
    getPricingPageRelayQueryVars("teamwork-collection", window.location),
    RELAY_API_CONTENTFUL
);
